import cx from 'classnames';
import type { PropsWithChildren } from 'react';

import Icon from 'components/Icon/Icon';
import SubHeader from 'components/SubHeader';
import useLayout, { LayoutType } from 'utils/layout';
import { Translation } from 'utils/translations';

import styles from './AuthLayout.module.scss';

type Props = PropsWithChildren & {
  className?: string;
  title: string;
};

const AuthLayout = ({ className, title, children }: Props) => {
  const layout = useLayout();

  return (
    <div className={cx(styles['auth-layout-wrapper'], styles[layout])}>
      <section
        className={cx(styles['auth-layout'], className, {
          [styles.mobile]: layout === LayoutType.mobile,
        })}
      >
        <SubHeader>
          <div className={styles.title}>
            <Icon name="profile-add" width={24} height={24} />
            <Translation message={title} />
          </div>
        </SubHeader>
        <div className={cx(styles.content, styles[layout])}>{children}</div>
      </section>
    </div>
  );
};

export default AuthLayout;
